import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import {Message} from '@aperza/ui';
import type AppConfig from '../domain/AppConfig';
import AppService from '../service/AppService';
const appConfig:AppConfig = AppService.appConfig();

export default class CatalogPageLink extends React.Component {

  /***************
   * Types for the New Catalog Page Link
   * Types : `button`, `link`, `href`
   */

  static propTypes = {
    children: PropTypes.any,
    companyContractDisplayId: PropTypes.string.isRequired,
    cluezCatalogId: PropTypes.string.isRequired,
    type: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    target: PropTypes.string,
    className: PropTypes.any
  };

  render() {

    let catalogPageUrl = `${appConfig.searchWebHost}/co/${this.props.companyContractDisplayId}/catalog/${this.props.cluezCatalogId}`;

    switch (this.props.type) {
      case 'button' :
        return (
          <Button target={this.props.target?this.props.target:'_self'} variant={this.props.variant} className={this.props.className} size={this.props.size} href={catalogPageUrl} >{this.props.children}</Button>
        );
        break;
      case 'link' :
        return (
          <a href={catalogPageUrl} target={this.props.target?this.props.target:'_self'} className={this.props.className}>{this.props.children}</a>
        );
        break;
      case 'href' :
        return <>catalogPageUrl</>;
        break;
      default :
        return <></>;
        break;
    }


  }

}
